import { motion } from "framer-motion";
import { FeatureCard } from "./FeatureCard";

export const CategorySection = ({ category, tags, industries, highlightedId }) => {
  if (!category.features || category.features.length === 0) return null;

  return (
    <section
      id={category.slug || category.id}
      data-testid={`category-${category.slug || category.id}`}
      className="scroll-mt-20 py-16 sm:py-24 border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="grid lg:grid-cols-12 gap-8 mb-10 sm:mb-14 items-end"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <span className="font-mono-ui text-[11px] uppercase tracking-[0.22em] text-neutral-500">
                Use case · {category.index}
              </span>
              <span className="h-px flex-1 bg-neutral-200" />
            </div>
            <h2
              data-testid={`category-title-${category.slug || category.id}`}
              className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-black text-neutral-950 tracking-tight leading-tight"
            >
              {category.name}.{" "}
              <span className="text-neutral-400">{category.tagline}</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-neutral-600 leading-relaxed">
              {category.summary}
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {category.features.map((f) => (
            <FeatureCard
              key={f.id}
              feature={f}
              tags={tags}
              industries={industries}
              highlighted={highlightedId === f.id}
              categoryName={category.name}
              categorySlug={category.slug || category.id}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
